import React from 'react';
import MapPin from './map-pin';
import StoreTag from './StoreTag';
//TODO: REMOVE INLINE STYLES!!!!!
export function StoreHeadline({ name, store, index, distance, showMobileStoreDetail, handleMobileThumbnailClicked, isInPostStoreLocatorRebrandEnabled }) {
  const htmlMapPin = () => {
    const mapPin = new MapPin(store, isInPostStoreLocatorRebrandEnabled);

    return (
      <div 
        className="phase-2-numeric-map-pin-list-item"
        style={{alignItems: "center", display: "flex", justifyContent: "center"}}
      >
        <img
          src={mapPin.icon()}
          alt="pin-icon"
          className="pin"
        />
        {(!isInPostStoreLocatorRebrandEnabled || store.store_type !== 'PaypointStore') &&
          <span
            style={{fontWeight: "bold", fontSize: 11, marginBottom: 6, marginRight: 2, position: "absolute"}}
            className={mapPin.numberClass()}
          >
            {index + 1}
          </span>
        }
      </div>
    );
  };

  return(
    <div itemScope itemType="http://schema.org/Store"
      className={!showMobileStoreDetail ? "" : "yodel-store-headline -flex-column"} id="yodel-store-headline">
      {
        showMobileStoreDetail &&
          <h4 onClick={() => handleMobileThumbnailClicked()}>
            <img src="/assets/2017/icons/yodel-chevron.svg" alt="yodel-back-chevron" />
            Back to store locator
          </h4>
      }

      <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: 20, marginLeft: 10, marginRight: 10}}>
        <div style={{display: "flex", flexDirection: "row"}}>
          <div style={{width: 24, marginRight: 12, flexShrink: 0}}>
            {htmlMapPin()}
          </div>

          <h3 style={{color: "#1D1D1D", marginRight: 16, marginBottom: 0}}>{store.name}</h3>
        </div>

        <div style={{display: "flex", flexDirection: "column", flexShrink: 0}}>
          <StoreTag store={store.store_type} isInPostStoreLocatorRebrandEnabled={isInPostStoreLocatorRebrandEnabled} />
        </div>
      </div>
    </div>
  );
}
